import { Alert } from '@argink/ui';
import { LinkButton } from '../components/layout/LinkButton';
import { BACK_TO_OVERVIEW } from '../lib/copy';

export function NotFoundPage() {
  return (
    <div className="not-found-page">
      <Alert tone="warning" title="Página não encontrada">
        O endereço acessado não existe no ARGINK.
      </Alert>
      <LinkButton to="/dashboard">{BACK_TO_OVERVIEW}</LinkButton>
    </div>
  );
}
